// @ts-nocheck
/* eslint-disable */
export const managementIcon = {
        data: `<svg
    class="management-nav-icon"
    viewBox="0 0 100 100"
    fill="none">
 <path
        class="lower-hexagon"
        d="M48.0833 2.83864C49.2694 2.15388 50.7306 2.15388 51.9167 2.83864L89.8846 24.7594C91.0706 25.4442 91.8013 26.7097 91.8013 28.0792V71.9208C91.8013 73.2903 91.0706 74.5558 89.8846 75.2406L51.9167 97.1614C50.7306 97.8461 49.2694 97.8461 48.0833 97.1614L10.1154 75.2406C8.92936 74.5558 8.19873 73.2903 8.19873 71.9208V28.0792C8.19873 26.7097 8.92936 25.4442 10.1154 24.7594L48.0833 2.83864Z"
        stroke-width="3" />
    <g style="mix-blend-mode: soft-light">
        <path
            class="upper-hexagon-shade"
            d="M50 8L87 29.7166V48.2875C87 48.2875 76.7767 57 50 57C24.6328 57 13 48.2875 13 48.2875V30L50 8Z" />
        <path
            d="M14 30.5688L50.0033 9.16146L86 30.2892V47.7954C85.9763 47.8127 85.9514 47.8308 85.9252 47.8495C85.6165 48.0712 85.1369 48.3955 84.474 48.7888C83.1485 49.5752 81.0886 50.6379 78.1951 51.7056C72.4099 53.8403 63.2778 56 50 56C37.4335 56 28.2975 53.8424 22.3246 51.7024C19.3372 50.632 17.1385 49.565 15.6954 48.7724C14.9739 48.376 14.4412 48.0482 14.0932 47.8227C14.0605 47.8015 14.0294 47.7812 14 47.7618V30.5688Z"
            stroke="black"
            stroke-opacity="0.01"
            stroke-width="2" />
    </g>

      <path
        d="M70 63.819V60.6063C70 59.2036 68.8688 58.0271 67.4208 58.0271H64.9774V52.8235C64.9774 52.371 64.6154 51.9638 64.1176 51.9638H50.8597V48.3439H56.1538C58.009 48.3439 59.5475 46.8054 59.5475 44.9502V37.3937C59.5475 35.5385 58.009 34 56.1538 34H43.8462C41.991 34 40.4525 35.5385 40.4525 37.3937V44.9502C40.4525 46.8054 41.991 48.3439 43.8462 48.3439H49.1403V51.9638H35.8824C35.4299 51.9638 35.0226 52.3258 35.0226 52.8235V58.0271H32.5792C31.1765 58.0271 30 59.1584 30 60.6063V63.819C30 65.2217 31.1312 66.3982 32.5792 66.3982H39.1855C40.5882 66.3982 41.7647 65.267 41.7647 63.819V60.6063C41.7647 59.2036 40.6335 58.0271 39.1855 58.0271H36.7421V53.6833H49.1403V58.0271H46.6968C45.2941 58.0271 44.1176 59.1584 44.1176 60.6063V63.819C44.1176 65.2217 45.2489 66.3982 46.6968 66.3982H53.3032C54.7059 66.3982 55.8823 65.267 55.8823 63.819V60.6063C55.8823 59.2036 54.7511 58.0271 53.3032 58.0271H50.8597V53.6833H63.2579V58.0271H60.8145C59.4118 58.0271 58.2353 59.1584 58.2353 60.6063V63.819C58.2353 65.2217 59.3665 66.3982 60.8145 66.3982H67.4208C68.8235 66.3982 70 65.2217 70 63.819ZM42.2172 45.0407V37.4842C42.2172 36.5339 42.9864 35.81 43.8914 35.81H56.1991C57.1493 35.81 57.8733 36.5792 57.8733 37.4842V45.0407C57.8733 45.9909 57.1041 46.7149 56.1991 46.7149H43.8914C42.9864 46.7149 42.2172 45.9457 42.2172 45.0407ZM40.1357 60.6063V63.819C40.1357 64.3167 39.7285 64.6787 39.276 64.6787H32.6697C32.1719 64.6787 31.81 64.2715 31.81 63.819V60.6063C31.81 60.1086 32.2172 59.7466 32.6697 59.7466H39.276C39.7285 59.7466 40.1357 60.1538 40.1357 60.6063ZM54.2081 60.6063V63.819C54.2081 64.3167 53.8009 64.6787 53.3484 64.6787H46.7421C46.2443 64.6787 45.8824 64.2715 45.8824 63.819V60.6063C45.8824 60.1086 46.2896 59.7466 46.7421 59.7466H53.3484C53.8009 59.7466 54.2081 60.1538 54.2081 60.6063ZM68.2805 63.819C68.2805 64.3167 67.8733 64.6787 67.4208 64.6787H60.8145C60.3167 64.6787 59.9547 64.2715 59.9547 63.819V60.6063C59.9547 60.1086 60.362 59.7466 60.8145 59.7466H67.4208C67.9185 59.7466 68.2805 60.1538 68.2805 60.6063V63.819Z"
        fill="var(--icon-text)"
        stroke="var(--icon-text)"
        stroke-width="0.25" />


      <defs>
        <linearGradient
            id="paint0_linear_dark"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#4FC8EC" />
            <stop
                offset="1"
                stop-color="#2D3792" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_dark"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#2D3792" />
            <stop
                offset="1"
                stop-color="#4FC8EC" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_dark"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>

        <linearGradient
            id="paint0_linear_light"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1C3664" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_light"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1C3664" />
            <stop
                offset="1"
                stop-color="#1D53A4" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_light"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>
    </defs>
</svg>
`,
    name: 'management' as const
};